module.exports = __webpack_public_path__ + "static/media/icon-cogs.64ec026c.png";